module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/MATTRZ_CX_ZERO_w-b326b30dc27d08206d4d36e27484df1d.svg";